module.exports = __webpack_public_path__ + "assets/img/ArtyWilmotte_002.d20dd776-ps.jpg";